import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    quantity: Number,
    baseQuantity: Number,
    equivalence: Number
  };

  static targets = ["quantity", "equivalence"];

  quantityValueChanged() {
    if (this.quantityValue > 0) {
      this.quantityTarget.innerHTML = this.quantityValue;
      this.equivalenceTarget.innerHTML =
        (this.quantityValue / this.equivalenceValue) * this.baseQuantityValue;
    } else {
      this.quantityTarget.innerHTML = this.equivalenceValue;
      this.equivalenceTarget.innerHTML = this.baseQuantityValue;
    }
  }
}
